import {EVENTS_NAME} from '../../config.js'

const {LEAD_DETAIL_ADS_WITH_INSTALMENT} = EVENTS_NAME

// INPUT:  event='Lead Triggered', lead_type∈LEAD_TYPES, page_name_origin='detail', seller_type='profesional', has_instalment=true
// OUTPUT: ['Total Lead Detail Ads with instalment (web)']

export const getInstalmentDetailEvents = ({event, properties, isProfessionalSeller}) => {
  const matches =
    event === LEAD_DETAIL_ADS_WITH_INSTALMENT.EVENT &&
    properties.page_name_origin === LEAD_DETAIL_ADS_WITH_INSTALMENT.PAGE_NAME_ORIGIN &&
    isProfessionalSeller &&
    properties.has_instalment &&
    LEAD_DETAIL_ADS_WITH_INSTALMENT.LEAD_TYPES.includes(properties.lead_type)

  if (!matches) return []

  return [LEAD_DETAIL_ADS_WITH_INSTALMENT.EVENT_OPTIMIZELY]
}
